import React from "react";
import {styled, ThinScrollbar} from "@reside/ui";

/** Scroll region marker used by list-table dropdown flip detection. */
export const DASHBOARD_BOARD_SCROLL_DATA_ATTR = "data-dashboard-board-scroll";

/** Shared vertical + horizontal scroll region for dashboard grid and list views (minimap pairs with this). */
export const DashboardBoardScrollShell = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 1px; /* flex child needs bounded height so overflow:auto scrolls */
  width: 100%;
`;

const DashboardBoardScrollAreaBase = styled(ThinScrollbar)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  /* iOS Safari: enable momentum/native scroll in overflow containers. */
  -webkit-overflow-scrolling: touch;
  /* Chromium/Safari: hide native horizontal scrollbar; minimap replaces it. */
  &::-webkit-scrollbar:horizontal {
    height: 0;
  }
`;

export const DashboardBoardScrollArea = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof ThinScrollbar>
>((props, ref) => (
  <DashboardBoardScrollAreaBase
    ref={ref}
    {...{[DASHBOARD_BOARD_SCROLL_DATA_ATTR]: ""}}
    {...props}
  />
));

DashboardBoardScrollArea.displayName = "DashboardBoardScrollArea";
